import $ from "jquery";
import Validator from "./validation";
import BrowserDetect from 'utils/browserdetect';
import AutoFillController from 'components/autofill_controller';

const config = {
  selectors: {
    flyoutTrigger: '.js-header-account-flyout-trigger',
    flyoutElement: '.js-header-account-flyout',
    formLogin: '.js-form-flyout-login',
    formUsernameForgotten: '.js-form-flyout-username-forgotten',
    formPasswordForgotten: '.js-form-flyout-password-forgotten',
    formTriggerPasswordForgotten: '.js-trigger-flyout-password-forgotten',
    formTriggerUsernameForgotten: '.js-trigger-flyout-username-forgotten',
    formLoginTriggerPasswordForgotten: '.js-login-trigger-flyout-password-forgotten',
    formLoginTriggerUsernameForgotten: '.js-login-trigger-flyout-username-forgotten'
  },
  modifiers: {
    formHiddenClass: 'form--hidden',
    showFlyoutClass: 'header-nav__service-item--flyout'
  }
}

export default function HeaderLoginHandler(){
  this.browserDetect = new BrowserDetect();
  this.browserDetect.init();
  if (isIE11(this.browserDetect) || isEdge13OrOlder(this.browserDetect)) {
    console.log("Form validation for Internet Explorer 11 disabled!");
  } else {
    new Validator().initOnDomReady("form.js-checkout-login-form");
    new Validator().initOnDomReady("form.password-forgotten-form");
    new Validator().initOnDomReady("form.js-username-forgotten-form");
  }
  new AutoFillController().initOnDomReady();

  $(config.selectors.flyoutTrigger).on("mouseover", function(){
    $(this).addClass(config.modifiers.showFlyoutClass);
  }).on("mouseout", function(e){
    ($(e.target).is('input')) ? $(this).addClass(config.modifiers.showFlyoutClass) : $(this).removeClass(config.modifiers.showFlyoutClass);
  });

  $(config.selectors.flyoutElement).on("mouseleave", function(){
    $(this).removeClass(config.modifiers.showFlyoutClass);
  })

  $(config.selectors.formLoginTriggerPasswordForgotten).on("click", function () {
    $(config.selectors.formLogin).addClass(config.modifiers.formHiddenClass);
    $(config.selectors.formUsernameForgotten).addClass(config.modifiers.formHiddenClass);
    $(config.selectors.formPasswordForgotten).removeClass(config.modifiers.formHiddenClass);
  });

  $(config.selectors.formTriggerPasswordForgotten).on("click", function () {
    $(config.selectors.formLogin).removeClass(config.modifiers.formHiddenClass);
    $(config.selectors.formPasswordForgotten).addClass(config.modifiers.formHiddenClass);
  });

  $(config.selectors.formLoginTriggerUsernameForgotten).on("click", function () {
    $(config.selectors.formLogin).addClass(config.modifiers.formHiddenClass);
    $(config.selectors.formPasswordForgotten).addClass(config.modifiers.formHiddenClass);
    $(config.selectors.formUsernameForgotten).removeClass(config.modifiers.formHiddenClass);
  });

  $(config.selectors.formTriggerUsernameForgotten).on("click", function () {
    $(config.selectors.formLogin).removeClass(config.modifiers.formHiddenClass);
    $(config.selectors.formUsernameForgotten).addClass(config.modifiers.formHiddenClass);
  });
}

function isIE11(browserDetect) {
  return browserDetect.browser === "Explorer" && browserDetect.version === 11;
}

function isEdge13OrOlder(browserDetect) {
  return browserDetect.browser === "Edge" && browserDetect.version < 14;
}
